import axios from 'axios';
import {url} from './urls'

const clienteAxios = axios.create({
    baseURL : url+"api",
});

export default clienteAxios;